import React, { FC, ReactElement, useEffect } from 'react'
import { useHistory,useParams } from 'react-router-dom'

import { LeaveOfAbsenceEditContainer } from '../../containers'
import { LeaveOfAbsenceForm } from '../../entities/LeaveOfAbsences/LeaveOfAbsences'
import trans from '../../helpers/trans'
import {
    cancelLeaveOfAbsenceChangeRequest,
    fetchLeaveOfAbsencesDetail,
    requestLeaveOfAbsenceChange,
} from '../../redux/leaveOfAbsenceRequestDetail/leaveOfAbsenceRequestDetailActions'
import { useTypedDispatch,useTypedSelector } from '../../redux/store'

const ConnectedLeaveOfAbsenceEdit: FC = (): ReactElement => {
    const history = useHistory()
    const { id } = useParams<{ id: string }>()

    const dispatch = useTypedDispatch()

    const { leaveOfAbsenceRequestDetail, isLoading, isSuccessful } = useTypedSelector(
        state => state.pacoLeaveOfAbsenceRequestDetailReducer,
    )

    const handleSubmit = (formData: LeaveOfAbsenceForm): void => {
        dispatch(requestLeaveOfAbsenceChange(id, formData))
    }

    const handleCancelChangeRequest = (): void => {
        dispatch(cancelLeaveOfAbsenceChangeRequest(id))
    }

    useEffect(() => {
        dispatch(fetchLeaveOfAbsencesDetail(id))
    }, [id])

    useEffect(() => {
        if (isSuccessful) {
            history.push(`/${trans('nav.absences.link')}/${trans('nav.leaveOfAbsenceRequests.link')}`)
        }
    }, [isSuccessful])

    return (
        <LeaveOfAbsenceEditContainer
            leaveOfAbsence={leaveOfAbsenceRequestDetail}
            isLoading={isLoading}
            onSubmit={handleSubmit}
            onCancelChangeRequest={handleCancelChangeRequest}
        />
    )
}

export default ConnectedLeaveOfAbsenceEdit
